export default __webpack_public_path__ + "static/media/directUpload.8aeedf38.svg";